import { createContext, useContext, useEffect, useState } from "react";
import { IActionGroup, IActionData, IActionShellData, IActionJavaData } from "../action";
import { ITriggerGroup, ITriggerData, ITriggerShellData, ITriggerJavaData } from "../trigger";
import { ITriggerActionGroup, ITriggerAction } from "../trigger-action";
import { IProjectData } from "../project";
import { IGroup, GroupCheckList2, GroupCheckList1 } from "../common";
import { IChildToProjectData, projectDataToUniqueId } from "../utils";
import { StorePageContext, toProxy, useWatchUpdates, watchUpdates } from "@fanfanlo";
import _ from "lodash";

export const ProjectContext = createContext<IProjectData>({} as IProjectData)

export const TriggerActionGroupContext = createContext<ITriggerActionGroup>({} as ITriggerActionGroup)

export const TriggerActionContext = createContext<ITriggerAction>({} as ITriggerAction)

export const TriggerGroupContext = createContext<ITriggerGroup>({} as ITriggerGroup)

export const TriggerListContext = createContext<ITriggerData<ITriggerShellData, ITriggerJavaData>[]>([] as ITriggerData<ITriggerShellData, ITriggerJavaData>[])

export const TriggerContext = createContext<ITriggerData<ITriggerShellData, ITriggerJavaData>>({} as ITriggerData<ITriggerShellData, ITriggerJavaData>)

export const ActionGroupContext = createContext<IActionGroup>({} as IActionGroup)

export const ActionListContext = createContext<IActionData<IActionShellData, IActionJavaData>[]>([] as IActionData<IActionShellData, IActionJavaData>[])

export const ActionContext = createContext<IActionData<IActionShellData, IActionJavaData>>({} as IActionData<IActionShellData, IActionJavaData>)

export const GroupContext = createContext<IGroup<any>>({} as IGroup<any>)

export const GroupCheckList2Context = createContext<GroupCheckList2>([] as GroupCheckList2)

export const GroupCheckList1Context = createContext<GroupCheckList1>([] as GroupCheckList1)


export function useProjectUniqueKeyValue<T>(initProjectInfoFn:(projectInfo: IChildToProjectData) => void, key:string, defValue:T):[T, (v:T) => void, string]{
    const projectInfo: IChildToProjectData = {}
    initProjectInfoFn(projectInfo)
    const store = useContext(StorePageContext);
    const uniqueKey = `${key}:${projectDataToUniqueId(projectInfo)}`
    const [value, _setValue] = useState<T>(store.get(uniqueKey) as T || defValue)
    function setValue(v:T){
        _setValue(v)
        store.set(uniqueKey, v)
    }
    const v = _.isObject(value) ? toProxy(value) : value
    if(_.isObject(value)){
        useEffect(()=>{
            watchUpdates(value, (info)=>{
                store.set(uniqueKey, v)
                // 这里逻辑上返回的v是重新构建的，所以其它地方引用v的时候需要注意删除侦听，或者这里得寻找统一方法处理
                // setValue((_.isArray(value) ? [...value] : {...value}) as T)
            })
        }, [])
    }
    return [v, setValue, uniqueKey]
}